/*
 * use-dev-mode
 */
import { useContext } from "react"
import { DevContext } from "../dev.context"

type UseDevMode = {
	devMode: boolean
	setDevMode: (newDevMode: boolean, showToast?: boolean) => void
}

export function useDevMode(): UseDevMode {
	const context = useContext(DevContext)

	if (context === undefined) {
		throw new Error("useDevMode must be used within a DevProvider")
	}

	return { devMode: context.devMode, setDevMode: context.setDevMode }
}
